<template>
  <v-container
    id="banner-container-wrapper"
    :class="['banner-container-wrapper' , isBannerClosed ? 'hide':'show',
    isFloatingBanner ? '' :'fixed']">
    <div class="banner-container">
    <v-layout row class="container-layout">
      <v-flex xs6>
        <div class="banner-title-container" v-if="showBanner">
          <img class="feature-icon" src="../../assets/icons/feature-icon.svg" alt="feature icon" />
          <div class="banner-title" v-if="showBanner && getBanner.text">
            {{getBanner.text}}
          </div>
        </div>
      </v-flex>
      <v-flex xs6 class="banner-button-container">
        <div class="banner-button" v-if="showBanner && getBanner.actionText">
          <BaseButton
            id="detailsButton"
            type="button"
            class="details-button"
            :hgLabel="getBanner.actionText"
            @click="getDetailsButtonClick()"/>
        </div>
        <img
          class="close-icon"
          id="closeIcon"
          src="../../assets/icons/navigation-close.svg"
          alt="navigation close icon"
          @click="onCloseIconClick()"/>
      </v-flex>
    </v-layout>
  </div>
  </v-container>
</template>

<script>
import { Components } from '@homegauge/vue';
import { mapState } from 'vuex';

const { BaseButton } = Components;


export default {
  components: {
    BaseButton,
  },
  data() {
    return {
      isBannerClosed: false,
    };
  },
  props: {
    isFloatingBanner: {
      type: Boolean,
      default: true,
    },
    location: {
      type: String,
    },
    referrer: String,
  },
  mounted() {
    this.getBannerDetails();
  },
  watch: {
    location() {
      this.getBannerDetails();
    },
  },
  computed: {
    ...mapState('HomebuyerOffers', {
      getBanner: state => state.getBanner,
    }),
    showBanner() {
      return this.getBanner && Object.keys(this.getBanner).length > 0;
    },
  },
  methods: {
    trackButtonClick() {
      const clickAction = this.isBannerClosed ? 'dismiss' : 'click';
      this.$store.dispatch('HomebuyerOffers/trackBannerByAction', {
        action: clickAction,
        key: this.getBanner.key,
        location: this.location,
      });
    },
    getDetailsButtonClick() {
      this.trackButtonClick();
      this.redirectToOffers();
    },
    getBannerDetails() {
      this.$store.dispatch('HomebuyerOffers/getBannerDetails', {
        location: this.location,
      });
    },
    onCloseIconClick() {
      this.isBannerClosed = true;
      this.sendCloseEvent();
      this.trackButtonClick();
      sessionStorage.setItem('bannerDismissed', 'true');
    },
    sendCloseEvent() {
      this.$emit('closeBannerEvent');
    },
    redirectToOffers() {
      this.$router.push({
        path: '/offers',
        query: {
          referrer: this.referrer,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/breakpoints';

#banner-container-wrapper {
  padding: 0 20px;

  @include breakpoint(sm) {
    padding-top: 0;
    padding-bottom: 0;
  }
  &.fixed {
    position: sticky;
    top: 0;
    z-index: 3;
  }
  &.hide {
    display: none;
  }
  &.show {
    display: block;
  }
}

.banner-container {
  border: solid 2px #4b90e2;
  background-color: #4b90e2;
  min-height: 54px;
  width: 100%;
  padding: 9px;
  margin: 76px 0 24px 0;
  @include breakpoint(sm) {
    min-height: 68px;
    padding: 16px;
    margin: 26px 0 24px 0;
  }
  & .feature-icon {
    display: none;
    @include breakpoint(sm) {
      display: flex;
    }
  }
  & .container-layout {
    align-items: center;
  }
  & .banner-title-container {
    display: flex;
    & .banner-title {
      font-size: 15px;
      color: #fff;
      padding-left: 0;
      @include breakpoint(sm) {
        padding-left: 16px;
        font-size: 22px;

      }
    }
  }
  & .banner-button-container {
    display: flex;
    justify-content: center;
    @include breakpoint(sm) {
      justify-content: flex-end;
    }
    & .details-button {
      background-color: #4b90e2;
      border: solid 1px #fff;
      color: #fff;
      width: 121px;
      display: flex;
      justify-content: center;
      height: 36px;
      align-items: center;
    }
  }

  & .close-icon {
    padding-left: 4%;
    @include breakpoint(sm) {
      padding-left: 16px;
    }
  }
}
</style>
